// region fetch setup
const apiFetch = async (url, options = {}) => {
    const defaultOptions = {
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    }

  const response = await fetch(process.env.VUE_APP_API_URL + url, {
        ...defaultOptions,
        ...options,
        headers: {
            ...defaultOptions.headers,
            ...options.headers,
        },
    })
    return await response.json()
}


apiFetch.get = (url, params = null) => apiFetch(
    url + (params ? `?${new URLSearchParams(params).toString()}` : ''),
    { method: 'GET' }
)
apiFetch.post = (url, body) => apiFetch(url, { 
    method: 'POST', 
    body: JSON.stringify(body) 
})
apiFetch.put = (url, body) => apiFetch(url, { 
    method: 'PUT', 
    body: JSON.stringify(body) 
})
apiFetch.delete = (url, params = null) => apiFetch(
    url + (params ? `?${new URLSearchParams(params).toString()}` : ''),
    { method: 'DELETE' }
)
apiFetch.patch = (url, body) => apiFetch(url, {
    method: 'PATCH',
    body: JSON.stringify(body)
})
// endregion

// region requests
// region Sphere API
const getSpheres        = () => apiFetch.get('/spheres')
const getSphere         = (id) => apiFetch.get('/spheres/' + id)
const createSphere      = (data) => apiFetch.post('/spheres', data)
const patchSphere       = (id, data) => apiFetch.patch('/spheres/' + id, data)
const addPreference     = (sphereId, data) => apiFetch.post('/spheres/' + sphereId + '/preferences', data)
const patchPreference   = (sphereId, prefId, data) => apiFetch.patch('/spheres/' + sphereId + '/preferences/' + prefId, data)
const deletePreference  = (sphereId, prefId) => apiFetch.delete('/spheres/' + sphereId + '/preferences/' + prefId)
const addSphereWidget   = (sphereId, widget_type, catalog_widget_id = null) => apiFetch.post('/spheres/' + sphereId + '/widgets', { widget_type, catalog_widget_id })
const removeSphereWidget = (sphereId, widget_type, catalog_widget_id = null) => {
    const qs = catalog_widget_id != null ? '?catalog_widget_id=' + encodeURIComponent(catalog_widget_id) : ''
    return apiFetch.delete('/spheres/' + sphereId + '/widgets/' + encodeURIComponent(widget_type) + qs)
}
const addRecommendation = (sphereId, prefId, widget_type, catalog_widget_id = null) => apiFetch.post('/spheres/' + sphereId + '/preferences/' + prefId + '/recommended', { widget_type, catalog_widget_id })
const removeRecommendation = (sphereId, prefId, widget_type, catalog_widget_id = null) => {
    const qs = catalog_widget_id != null ? '?catalog_widget_id=' + encodeURIComponent(catalog_widget_id) : ''
    return apiFetch.delete('/spheres/' + sphereId + '/preferences/' + prefId + '/recommended/' + encodeURIComponent(widget_type) + qs)
}
const getWidgetTypes    = () => apiFetch.get('/widget-types')
// endregion

// region Catalog API (cabinet widget catalog managed by admin)
const getCatalog          = ()             => apiFetch.get('/catalog')
const getCatalogAdmin     = ()             => apiFetch.get('/catalog/admin')
const createCatalogSection = (data)        => apiFetch.post('/catalog/sections', data)
const patchCatalogSection  = (id, data)    => apiFetch.patch('/catalog/sections/' + id, data)
const deleteCatalogSection = (id)          => apiFetch.delete('/catalog/sections/' + id)
const createCatalogWidget  = (data)        => apiFetch.post('/catalog/widgets', data)
const patchCatalogWidget   = (id, data)    => apiFetch.patch('/catalog/widgets/' + id, data)
const deleteCatalogWidget  = (id)          => apiFetch.delete('/catalog/widgets/' + id)
// endregion

const getLimits = async () => {
    return await apiFetch.get('/limits')
}

const getModule = async (id) => {
    return await apiFetch.post('/modules', { id })
}

const getModuleBySlug = async (planId, slug) => {
    return await apiFetch.post('/modules/by-slug', { planId, slug })
}

const getModules = async () => {
    return await apiFetch.get('/modules')
}

const getPlanModules = async (planId) => {
    return await apiFetch.post('/modules/plan-modules', { planId })
}

const createModule = async (data) => {
    return await apiFetch.post('/modules/new', data)
}

const editModule = async (id, data) => {
    return await apiFetch.post('/modules/edit', { id, data })
}

const deleteModule = async (id) => {
    return await apiFetch.post('/modules/delete', { id })
}

const switchModule = async (planId, moduleId) => {
    return await apiFetch.post('/modules/switch', { planId, moduleId })
}

const getPlan = async (id) => {
    return await apiFetch.post('/plans', { id })
}

const getPlanWithLimits = async (id) => {
    return await apiFetch.post('/plans/with-limits', { id })
}

const getPlans = async (currentPage = '') => {
    return await apiFetch.get('/plans', { currentPage })
}

const getPlansWithLimits = async () => {
    return await apiFetch.get('/plans/with-limits')
}

const createPlan = async (data) => {
    return await apiFetch.post('/plans/new', data)
}

const editPlan = async (id, data) => {
    return await apiFetch.post(`/plans/${id}/edit`, data)
}

const deletePlan = async (id) => {
    return await apiFetch.delete(`/plans/${id}`,)
}

const updatePlanModule = async (plan_id, module_data) => {
    return await apiFetch.post(`/plans/${plan_id}/edit/modules`, module_data)
}

const createUser = async (user) => {
    return await apiFetch.post('/users/new', user )
}

const getUsers = async (currentPage = '', search = '', plan = '', dateFrom = '', dateTo = '') => {
    let params = { currentPage }
    if(search) params.search = search
    if(plan) params.plan = plan
    if(dateFrom) params.dateFrom = dateFrom
    if(dateTo) params.dateTo = dateTo
    return await apiFetch.get('/users/all', params)
}

const downloadUsers = async (format, search = '', plan = '', dateFrom = '', dateTo = '', locale = 'ru') => {
    const params = { locale }
    if(search) params.search = search
    if(plan) params.plan = plan
    if(dateFrom) params.dateFrom = dateFrom
    if(dateTo) params.dateTo = dateTo
    const url = process.env.VUE_APP_API_URL + `/users/export/${encodeURIComponent(format)}?${new URLSearchParams(params)}`
    const response = await fetch(url, { method: 'GET', credentials: 'include' })
    const contentType = response.headers.get('content-type') || ''
    if(!response.ok || contentType.includes('application/json')) {
        const error = contentType.includes('application/json') ? await response.json() : null
        throw new Error(error?.msg || 'Export failed')
    }
    const disposition = response.headers.get('content-disposition') || ''
    const filename = disposition.match(/filename="?([^";]+)"?/i)?.[1] || `superqr-clients.${format}`
    return { blob: await response.blob(), filename }
}

const getUser = async () => {
    return await apiFetch.get('/users')
}

const updateUser = async (user) => {
    return await apiFetch.post('/users/edit', user)
}

const getUserById = async (id) => {
    return await apiFetch.post('/users', { id })
}

const deleteUser = async (id) => {
    return await apiFetch.post('/users/delete', { id })
}

const confirmUser = async (id) => {
    return await apiFetch.post('/users/confirm', { id })
}

const getUserSurveys = async (id) => {
    return await apiFetch.get(`/users/${id}/surveys`)
}

const changePassword = async (userId, passwords) => {
    return await apiFetch.post('/users/change-password', { userId, passwords })
}

const purchase = async (amount, plan_id, user_id, provider = 'garantpay') => {
    return await apiFetch.post('/billing/purchase', { amount, plan_id, user_id, provider })
}

const getTransactionStatus = async (id) => {
    return await apiFetch.get(`/billing/transaction/${id}/status`)
}

const login = async (username, password) => {
    return await apiFetch.post('/auth/login', { username, password })
}

const logout = async () => {
    return await apiFetch.post('/auth/logout')
}
// endregion

// region briefs (админ: раздел «Брифы»)
const getBriefs = (params = null) => apiFetch.get('/briefs', params)
const createBrief = (data) => apiFetch.post('/briefs', data)
const revokeBrief = (id) => apiFetch.post(`/briefs/${id}/revoke`, {})
const rebuildBrief = (id) => apiFetch.post(`/briefs/${id}/rebuild`, {})
// endregion

// region exports
export default {
    addPreference,
    addRecommendation,
    addSphereWidget,
    changePassword,
    confirmUser,
    createModule,
    createBrief,
    createPlan,
    createCatalogSection,
    createCatalogWidget,
    createSphere,
    createUser,
    deleteCatalogSection,
    deleteCatalogWidget,
    deleteModule,
    deletePreference,
    deletePlan,
    rebuildBrief,
    revokeBrief,
    deleteUser,
    editModule,
    editPlan,
    getBriefs,
    getCatalog,
    getCatalogAdmin,
    getLimits,
    getModule,
    getModuleBySlug,
    getModules,
    getPlan,
    getPlanModules,
    getPlanWithLimits,
    getPlans,
    getPlansWithLimits,
    getSphere,
    getSpheres,
    getUser,
    getUserById,
    getUserSurveys,
    getTransactionStatus,
    getUsers,
    downloadUsers,
    getWidgetTypes,
    login,
    logout,
    patchCatalogSection,
    patchCatalogWidget,
    patchPreference,
    patchSphere,
    purchase,
    removeRecommendation,
    removeSphereWidget,
    switchModule,
    updatePlanModule,
    updateUser
}
